<template>
    <div>
        <el-upload v-if="!flBodyfile.id" ref="upload" :on-change="handleUploadChange" action="" multiple="false" :file-list="fileList" :show-file-list="false" :auto-upload="false" :with-credentials="true" :accept="accept">
            <el-input v-model="flBodyfile.file.name" name="bodyfileName" placeholder="请上传">
                <el-button slot="append" size="mini" icon="el-icon-upload2" />
            </el-input>
        </el-upload>
        <div v-if="flBodyfile && flBodyfile.id" style="width: 100%; display: flex">
            <div style="width: calc(100% - 216px)">
                <div style="font-size: 16px; margin-right: 5px; display: inline-block">
                    <img :src="imgUrl(flBodyfile)" style="width: 12px; position: relative; top: 3px" alt="" />
                </div>
                <el-link style="margin-right: 4px" type="primary" :underline="false" @click="viewBodyfile(flBodyfile)">{{ flBodyfile.fileName }}</el-link>
                <el-link v-if="flDocfile && downloadDoc" class="docfileIcon" type="primary:" title="下载文件" icon="el-icon-download" :underline="false" @click="downloadDocfile(flDocfile)" />
                <el-link v-if="(curTN.tnCanEdit === 1 && curTN.userName === flBodyfile.uploadBy && flBodyfile.notDelete !== true) || (deleteFileNodes && curTN.tnNodeName && deleteFileNodes.indexOf(curTN.tnNodeName) > -1)" class="removeBodyfileIcon" type="danger" title="删除文件" icon="el-icon-close" :underline="false" @click="removeBodyfile(flBodyfile)" />
                <div v-if="extName === '.pdf' && fileNeedSign == 1" style="float: right"><el-button v-text-lbl="'ecwapp.PdfTools.sgnature'" size="mini" style="border: 0px" @click="viewBodyfile(flBodyfile, 'sign')">签名</el-button></div>
                <div v-if="flBodyfile.fileId" style="float: right"><el-button v-text-lbl="'BodyFile.historicalVersion'" size="mini" style="border: 0px" @click="viewHistoryfile(flBodyfile)">历史版本</el-button></div>
            </div>
            <div style="float: left; width: 216px; display: inline-block" class="removeBodyfileIcon">
                <span style="color: #a7a7a7; padding-right: 5px">{{ flBodyfile.uploadTime }}</span>
                <span style="color: #a7a7a7; padding-left: 5px; padding-right: 5px">{{ flBodyfile.fileSize }}</span>
            </div>
        </div>
        <div v-if="historyDialogVisible" class="file-right-box">
            <div class="right-box-div1">
                <el-row class="navbar">
                    <el-col v-text-lbl="'BodyFile.historicalVersion'" :span="20">历史版本</el-col>
                    <el-col :span="4"><i class="el-icon-close" @click="historyDialogVisible = false" /></el-col>
                </el-row>
                <el-scrollbar :native="false">
                    <div v-for="(attach, index) in historyFiles.filter((obj) => obj.fileName.indexOf('.doc') === -1 || obj.filePath.indexOf('/noTracks/') !== -1)" :key="index" class="fileitem">
                        <div style="cursor: pointer" @click="viewBodyfile(attach)">
                            <el-row style="line-height: 28px">
                                <el-col :span="4"><el-avatar size="small" :src="attach.avatarUrl" /></el-col>
                                <el-col :span="6">{{ attach.updateBy }}</el-col>
                                <el-col :span="14" style="text-align: right">{{ attach.updateTime }}</el-col>
                            </el-row>
                        </div>
                        <el-row>
                            <el-col :span="14" style="padding-left: 5px">
                                <div style="cursor: pointer" @click="viewBodyfile(attach)">{{ attach.fileVer }}&nbsp;</div>
                            </el-col>
                            <el-col :span="6">{{ attach.fileStatus == 1 ? '当前版本' : '历史版本' }}</el-col>
                            <el-col style="text-align: right" :span="4">
                                <el-dropdown @command="moreMenuitemClick">
                                    <span class="el-dropdown-link">
                                        <i class="el-icon-more" />
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-text-lbl="'pageBtns.look'" icon="el-icon-view" :command="'view_' + attach.id">查看</el-dropdown-item>
                                        <el-dropdown-item v-if="(curTN.tnCanEdit === 1 && curTN.userName === flBodyfile.uploadBy) || (deleteFileNodes && curTN.tnNodeName && deleteFileNodes.indexOf(curTN.tnNodeName) > -1)" v-text-lbl="'pageBtns.del'" icon="el-icon-close" :command="'remove_' + attach.id">删除</el-dropdown-item>
                                        <el-dropdown-item v-text-lbl="'pageBtns.download'" icon="el-icon-download" :command="'download_' + attach.id">下载</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </el-col>
                        </el-row>
                    </div>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import { formatFileSize, formatTime } from '@/global/utils/index'
import { mapGetters } from 'vuex'

export default {
    name: 'BodyFile',
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        curTN: {
            type: Object,
            default: function () {
                return {}
            }
        },
        flBodyfile: {
            type: Object,
            default: function () {
                return { file: { name: '' } }
            }
        },
        attachments: {
            type: Array,
            default: function () {
                return []
            }
        },
        wfAttachUrl: { type: String, default: 'wfInstance/wfBusiAttach' },
        fileNeedSign: { type: Number, default: 0 },
        accept: { type: String, default: '.doc,.docx,.pdf' },
        viewer: { type: String, default: 'pdfjs' },
        viewerUrlParams: { type: String, default: '' }, // 在线预览扩展参数
        bodyFileTitle: { type: String, default: '文件正文' },
        fileIsMust: { type: Number, default: 0 },
        autoSave: { type: Boolean, default: false },
        saveToPdf: { type: Boolean, default: true },
        waterMark: { type: Boolean, default: false },
        downloadDoc: { type: Boolean, default: false },
        markContent: { type: String, default: '' },
        deleteFileNodes: { type: String, default: '' }
    },
    data() {
        return {
            extName: '',
            flDocfile: null,
            historyFiles: [],
            historyDialogVisible: false,
            loading: true,
            isPdfFileStampType: false,
            haveFile: false,
            flBodysignedFile: { fileName: '' }
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {
        flBodyfile() {
            if (this.flBodyfile !== null) {
                this.setExtName()
            } else {
                this.flBodyfile = { file: { name: '' } }
            }
        }
    },
    created() {
        if (this.flBodyfile !== null) {
            this.setExtName()
        } else {
            this.flBodyfile = { file: { name: '' } }
        }

        this.$bus.on('uploadBodyFile', this.uploadBodyFile)
        this.$bus.on('setBodyfile', this.getBodyFile)
    },
    beforeDestroy() {
        this.$bus.off('uploadBodyFile', this.uploadBodyFile)
        this.$bus.off('setBodyfile', this.getBodyFile)
    },
    mounted() {},
    methods: {
        uploadBodyFile() {
            document.querySelector('.uploadBodyBtn').click()
        },
        getBodyFile(val) {
            debugger
            this.flBodyfile = val
        },
        setExtName() {
            if (this.flBodyfile === undefined || this.flBodyfile === null) this.flBodyfile = { file: { name: '' } }
            if (this.flBodyfile && this.flBodyfile.originalName) {
                const oriangialName = this.flBodyfile.originalName.replace('.des', '').replace('.xor', '').replace('.rsm3', '').replace('.sm4', '')
                this.extName = oriangialName.substring(oriangialName.lastIndexOf('.')).toLowerCase()

                this.flDocfile = null
                this.attachments.forEach((attach) => {
                    if (attach.fileType === 'BODY' && attach.filePath.indexOf('/noTracks/') === -1 && (attach.originalName === this.flBodyfile.originalName.replace(this.extName, '.doc') || attach.originalName === this.flBodyfile.originalName.replace(this.extName, '.docx'))) {
                        this.flDocfile = attach
                    }
                })
            }
        },
        viewBodyfile(flBodyfile, sign) {
            if (flBodyfile.id === undefined) return

            if (this.extName === '.pdf' && (this.viewer === 'pdfjs' || sign === 'sign')) {
                let fileurl = process.env.VUE_APP_BASE_API + '/' + this.wfAttachUrl + '/downloadById?inline=true&attachIds=' + flBodyfile.id + '&saveAs=' + this.flBodyfile.fileName
                fileurl += '&httpPort=' + location.port
                if (sign === 'sign') {
                    fileurl += '&fileName=' + decodeURIComponent(this.flBodyfile.fileName)
                    window.open('#/viewpdffile?sign&fileurl=' + encodeURIComponent(encodeURIComponent(fileurl)))
                } else {
                    fileurl += '&fileName=' + decodeURIComponent(this.flBodyfile.fileName)
                    window.open('/plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(fileurl + (this.waterMark ? '&waterMark=' + this.waterMark + '&markContent=' + this.markContent : '')))
                }
            } else if (this.viewer.indexOf('dcs=') === 0) {
                this.$http({
                    method: 'GET',
                    url: 'base/user/getSessionId'
                }).then((res) => {
                    if (res.code === 'success') {
                        const tSessionId = res.body.tSessionId
                        const hostname = location.href.split('#')[0]
                        let downUrl = hostname.substring(0, hostname.length - 1) + process.env.VUE_APP_BASE_API + '/' + this.wfAttachUrl + '/downloadById?attachIds=' + flBodyfile.id + '&httpPort=' + location.port + '&tSessionId=' + tSessionId

                        let convertType = '0'
                        if (this.extName === '.ofd') {
                            convertType = '21'
                        } else if (this.extName === '.pdf' || this.extName === '.pdfx') {
                            convertType = '20'
                        }

                        downUrl = this.viewer.split('=')[1] + '/composite/httpfile?convertType=' + convertType + '&fileUrl=' + encodeURIComponent(downUrl)
                        if (this.viewerUrlParams) {
                            downUrl += '&' + this.viewerUrlParams
                        }
                        if (downUrl.indexOf('&acceptTracks=0') === -1) {
                            downUrl += '&acceptTracks=0'
                        }

                        this.$bus.emit('showDoingDialog', '正在下载文件，请稍候...')
                        $.post(
                            downUrl,
                            {},
                            (res) => {
                                this.$bus.emit('closeDoingDialog')
                                if (res.errorcode === 0) {
                                    window.open(res.data.viewUrl)
                                } else {
                                    this.$alert(res.message, '操作提示', { type: 'error' })
                                }
                            },
                            'json'
                        )
                    }
                })
            } else {
                const downUrl = process.env.VUE_APP_BASE_API + '/' + this.wfAttachUrl + '/downloadById?inline=true&attachIds=' + flBodyfile.id + '&httpPort=' + location.port + (this.waterMark ? '&waterMark=' + this.waterMark + '&markContent=' + this.markContent : '')
                window.open(downUrl)
            }
        },
        downloadDocfile(flDocfile) {
            const downUrl = process.env.VUE_APP_BASE_API + '/' + this.wfAttachUrl + '/downloadById?attachIds=' + flDocfile.id + '&httpPort=' + location.port
            window.open(downUrl)
        },
        removeBodyfile(flBodyfile) {
            let confirmMsg = '您是否确认删除当前的文件？'
            if (flBodyfile.fileStatus === 8) {
                confirmMsg = '您是否确认删除历史版本文件？'
            }

            var _this = this
            this.$confirm(confirmMsg, '确认操作', { type: 'warning' }).then(async () => {
                if (flBodyfile.fileStatus !== 8) {
                    document.querySelector('.removeBodyfileIcon').innerHTML = '正在删除...'
                }
                var deleteIds = flBodyfile.id

                this.$http({
                    method: 'DELETE',
                    contentType: 'application/x-www-form-urlencoded',
                    params: { attachIds: deleteIds },
                    url: this.wfAttachUrl + '/delete'
                }).then((res) => {
                    if (res.code === 'success') {
                        const $scope = _this.$parent.$vnode.context

                        if (flBodyfile.fileStatus !== 8) {
                            if (typeof this.vo.flBodyFilename !== 'undefined') this.vo.flBodyFilename = null
                            if (typeof this.vo.signedFileName !== 'undefined') this.vo.signedFileName = null //盖章文件名
                            if (typeof this.vo.sealFileName !== 'undefined') this.vo.sealFileName = null //签章平台文件名

                            $scope.commandBar.forEach((btn) => {
                                if (btn.btnCode === 'btnOpenWordClick') {
                                    btn.btnShow = true
                                }
                            })

                            let haveDoc = 0
                            var originalName = flBodyfile.originalName.substring(0, flBodyfile.originalName.indexOf('.'))
                            var delFileName = ''
                            if ($scope.noTracksFile && $scope.noTracksFile.id === flBodyfile.id) {
                                delFileName = $scope.noTracksFile.fileName.split('.')[0]
                            } else if ($scope.redTitleFile && $scope.redTitleFile.id === flBodyfile.id) {
                                delFileName = $scope.redTitleFile.fileName.split('.')[0]
                            }

                            let docEditMode = ''
                            if ($scope.wfInstance.passenger.docEditMode) {
                                // 当前模式获取
                                docEditMode = $scope.wfInstance.passenger.docEditMode
                            }

                            //删除同一文件的其它格式复本
                            for (var i = 0; i < $scope.attachments.length; i++) {
                                if ($scope.attachments[i].fileType === 'BODY') {
                                    if ($scope.attachments[i].id === flBodyfile.id || $scope.attachments[i].originalName.split('.')[0] === originalName || $scope.attachments[i].fileName.split('.')[0] === delFileName) {
                                        //删除同一版本对应的doc、pdf副本
                                        $scope.attachments.splice(i--, 1)
                                    }
                                }
                            }
                            //如果有恢复的历史版本，追加到attachments
                            if (res.body.restoredFiles && res.body.restoredFiles.length > 0) {
                                res.body.restoredFiles.push(...$scope.attachments)
                                $scope.attachments = res.body.restoredFiles
                            }
                            //检查是否还有其它版本正文
                            for (var j = 0; j < $scope.attachments.length; j++) {
                                if ($scope.attachments[j].fileType === 'BODY') {
                                    if ($scope.attachments[j].fileName.indexOf('RedTitle_') !== -1 || $scope.attachments[j].fileName.indexOf('SignedFile_') !== -1) {
                                        //有套红文件或盖章文件
                                        haveDoc = 2
                                    } else if ($scope.attachments[j].fileName.indexOf('NoTracks_') !== -1 || $scope.attachments[j].originalName.indexOf($scope.wfInstance.bodyDocId + '.doc') === 0) {
                                        //有清稿文件或带修订痕迹文件
                                        if (docEditMode === 'NoTitle') {
                                            //无红头模式、有正文
                                            haveDoc = 1
                                        } else {
                                            //带红头模式、有正文
                                            haveDoc = 2
                                        }
                                    }
                                }
                            }
                            $scope.bodyfile = { file: { name: '' } }
                            this.$nextTick(() => {
                                $scope.$wfEngine.setFlBodyFile($scope)
                            })
                            if ($scope.wfInstance.haveDoc !== haveDoc) {
                                $scope.wfInstance.haveDoc = haveDoc
                                $scope.btnSubmitClick('AutoSave')
                            }
                        } else {
                            this.viewHistoryfile(this.flBodyfile)
                        }
                    } else {
                        this.$alert(res.message, '操作提示', { type: 'error' })
                    }
                })
            })
        },
        handleUploadChange(file, fileList) {
            const extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
            if (this.accept.indexOf(extName) === -1) {
                this.$alert(this.$tx('ecwapp.Wflowform.BodyFile.errFileFormat', { accept: this.accept.replace(/,/g, '、') }, `您上传的文件格式有误，仅支持${this.accept.replace(/,/g, '、')}格式的文件！`), '操作提示', { confirmButtonText: '确定', type: 'warning' })
                this.fileList = []
                return
            }
            if (this.flBodyfile != null && this.flBodyfile.name !== '') {
                for (var i = 0; i < this.attachments.length; i++) {
                    if (this.attachments[i].name === this.flBodyfile.name && this.attachments[i].fileType === 'BODY' && this.attachments[i].uploadTime === '待上传') {
                        this.attachments.splice(i--, 1)
                    }
                }
            }
            const attach = {}
            attach.fileName = file.name
            attach.fileSize = formatFileSize(file.size)
            attach.fileType = 'BODY'
            attach.uploadBy = this.loginUser.personName
            attach.uploadTime = '待上传'
            attach.saveToPdf = this.saveToPdf
            attach.file = file
            attach.checked = false
            file.progress = 0

            this.flBodyfile = attach
            this.$parent.$vnode.context.bodyfile = attach

            if (this.autoSave) {
                // this.$bus.emit('showDoingDialog', '正在上传正文...')
                this.$parent.$vnode.context.btnSubmitClick('AutoSave')
            }
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done()
                })
                .catch((_) => {})
        },
        handleUploadsignedFile(file, fileList) {
            const extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
            if (extName !== '.pdf') {
                this.$alert('您上传的文件格式有误，仅支持PDF格式的文件！', '操作提示', { confirmButtonText: '确定', type: 'warning' })
                this.fileList = []
                return
            }
            if (this.flBodyfile != null && this.flBodyfile.name !== '') {
                for (var i = 0; i < this.attachments.length; i++) {
                    if (this.attachments[i].name === this.flBodyfile.name && this.attachments[i].fileType === 'BODY' && this.attachments[i].uploadTime === '待上传') {
                        this.attachments.splice(i--, 1)
                    }
                }
            }
            this.flBodysignedFile.fileName = file.name
            this.flBodyfile = { file: { name: '' } } // 上传盖章文件载荷
            console.log(this.bodyfile)
            const attach = {}
            attach.fileName = file.name
            attach.fileSize = formatFileSize(file.size)
            attach.fileType = 'BODY'
            attach.uploadBy = this.loginUser.personName
            attach.uploadTime = '待上传'
            attach.file = file
            attach.file.name = 'SignedFile_' + this.$parent.$vnode.context.wfInstance.bodyDocId + extName
            attach.checked = false
            //this.$parent.$vnode.context.vo.signedFileName = 'SignedFile_' + this.$parent.$vnode.context.wfInstance.bodyDocId + extName
            //this.$parent.$vnode.context.signedFileName = this.$parent.$vnode.context.vo.signedFileName
            file.progress = 0
            this.haveFile = true
            this.flBodyfile = attach
            this.$parent.$vnode.context.bodyfile = attach

            console.log('上传盖章文件', this.bodyfile)
        },
        async StampClick() {
            if (!this.haveFile) {
                this.$message.warning('当前还未上传盖章文件,不能保存！')
                return
            }
            this.$bus.emit('showDoingDialog', '正在上传盖章文件...')
            try {
                await this.$parent.$vnode.context.btnSubmitClick('AutoSave')
                this.isPdfFileStampType = false
            } catch (error) {
                console.error(error)
            }
        },

        viewHistoryfile(file) {
            this.loading = true
            this.historyDialogVisible = true

            const listdataUrl = this.wfAttachUrl + '/listAttach'

            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: { pageNum: 1, pageSize: 1000, orderBy: 'fileVer desc', urlsearch: 'fileId:' + file.fileId },
                url: listdataUrl
            }).then((res) => {
                if (res.code === 'success') {
                    this.historyFiles = res.body.pageInfo.list.filter((attach) => {
                        attach.updateTime = formatTime(attach.updateTime)
                        attach.avatarUrl = process.env.VUE_APP_BASE_API + '/base/user/downloadPhotoByAccount?orgCode=' + attach.orgCode + '&account=' + attach.updateBy + '&httpPort=' + location.port
                        return true
                    })
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
                this.loading = false
            })
        },
        moreMenuitemClick(command) {
            const files = this.historyFiles.filter((file) => {
                if (command.indexOf(file.id) > 0) {
                    return true
                }
            })

            if (command.indexOf('view') !== -1) {
                this.viewBodyfile(files[0])
            } else if (command.indexOf('remove') !== -1) {
                this.removeBodyfile(files[0])
            } else if (command.indexOf('download') !== -1) {
                let attachIds = files[0].id
                this.historyFiles.forEach((attach) => {
                    if (attach.fileVer && attach.fileVer === files[0].fileVer && attach.id !== files[0].id) {
                        attachIds += ',' + attach.id
                    }
                })
                const downUrl = process.env.VUE_APP_BASE_API + '/' + this.wfAttachUrl + '/downloadById?attachIds=' + attachIds + '&httpPort=' + location.port + '&saveAs=文件正文_' + files[0].fileVer + '.zip'
                window.open(downUrl)
            }
        },
        // 返回图片路径
        imgUrl(item) {
            // 文件类型
            var extension = item.oriangialName || item.fileName
            extension = extension.substring(extension.lastIndexOf('.'))
            if (extension === '.doc' || extension === '.docx') {
                return 'images/w-imgs/email/word.png'
            }
            if (extension === '.ppt' || extension === '.pptx') {
                return 'images/w-imgs/email/ppt.png'
            }
            if (extension === '.xls' || extension === '.xlsx') {
                return 'images/w-imgs/email/excel.png'
            }
            if (extension === '.pdf') {
                return 'images/w-imgs/email/pdf.png'
            }
            if (extension === '.ofd') {
                return 'images/w-imgs/email/ofd.png'
            }
            if (extension === '.txt') {
                return 'images/w-imgs/email/txt.png'
            } else if (extension === '.audio' || extension === '.amr' || extension === '.mp3' || extension === '.wav') {
                return 'images/w-imgs/email/audio.png'
            } else if (extension === '.video' || extension === '.mp4' || extension === '.mov') {
                return 'images/w-imgs/email/video.png'
            } else if (extension === '.zip' || extension === '.rar') {
                return 'images/w-imgs/email/zip.png'
            } else if (extension === '.image' || extension === '.mp4' || extension === '.jpg' || extension === '.jpeg' || extension === '.png' || extension === '.gif' || extension === '.bmp' || extension === '.svg') {
                return 'images/w-imgs/email/picture.png'
            } else if (extension === ' ') {
                return 'images/w-imgs/email/none.png'
            } else {
                return 'images/w-imgs/email/其他.png'
            }
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-upload--text {
    width: 100%;
}
/deep/ .el-upload .el-input-group .el-input__inner {
    display: inline-block;
    vertical-align: baseline;
}

.docfileIcon {
    padding-left: 10px;
    padding-right: 10px;
}

.file-right-box {
    position: fixed;
    bottom: 0;
    top: 73px;
    height: calc(100vh - 73px) !important;
    z-index: 1199;

    .right-box-div1 {
        float: left;
        height: 100%;
        background: #fff;
        border-left: 1px solid #ddd;
        overflow: hidden;
        font-size: 14px;
        /deep/ .el-scrollbar {
            height: calc(100vh - 112px);
            width: 100%;
            .el-scrollbar__wrap {
                // overflow-y: auto;
                overflow-x: auto;
            }
        }

        .navbar {
            padding: 11px 12px 10px 12px;
            font-size: 14px;
            font-weight: 600;
            display: flex;

            /deep/ .el-icon-close {
                float: right;
                cursor: pointer;
            }
        }
        .fileitem {
            padding: 10px;
            font-size: 13px;
            border-bottom: solid 1px #f3f3f3;
            border-top: solid 1px #f3f3f3;

            .el-dropdown-link {
                cursor: pointer;
            }
        }
    }
}

@media (max-width: 1569px) {
    .right-box-div1 {
        width: 280px;
    }
}
@media (min-width: 1570px) {
    .right-box-div1 {
        width: 350px;
    }
}

.sidebar-area {
    border-bottom: solid 1px #eeeeee;
    .sidebar-area-title {
        font-weight: 600;
        line-height: 24px;
        padding: 10px;
        .el-button--primary {
            width: 6px;
            padding: 0px;
            margin-right: 6px;
            margin-top: 5px;
            border-radius: 1px;
            height: 14px;
            cursor: default;
            vertical-align: top;
            display: inline-block;
        }
        div {
            display: inline-block;
            vertical-align: top;
        }
        i {
            margin: 3px 5px 0px 10px;
            font-size: 14px;
        }
    }
    .sidebar-area-content {
        padding-left: 20px;
        padding-right: 10px;
        padding-bottom: 10px;

        .attach-row {
            line-height: 21px;

            .attach-name {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }
        }
    }
}
</style>
